<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Work Detail</md-icon>
                    </div>
                    <h4 class="title">Edit Work Detail</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Commodity
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workDetail.commodity" />
                                    <validation-error :errors="apiValidationErrors.commodity" />
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Item Number
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-input v-model="workDetail.item_number" name="item_number">
                                            {{ workDetail.item_number }}
                                    </md-input>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Date
                            </label>
                            <div class="md-layout-item">
                                <md-datepicker
                                        v-model="workDetail.date"
                                        :md-model-type="String"
                                        :class="{ 'md-invalid': !!apiValidationErrors.date }"
                                >
                                    <label>Select date ...</label>
                                    <validation-error :errors="apiValidationErrors.date" />
                                </md-datepicker>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Remarks
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workDetail.remarks"/>
                                    <validation-error :errors="apiValidationErrors.remarks"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Work Item
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="workDetail.workItem.id" name="workItems">
                                        <md-option
                                                v-for="workItem in available_workItems_dropdown"
                                                :key="workItem.id"
                                                :value="workItem.id"
                                        >
                                            {{ workItem.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Item Type
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <md-input v-model="workDetail.item_type" name="item_type">
                                        {{ workDetail.item_type }}
                                    </md-input>
                                </md-field>
                        </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Work Detail</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        workDetail: {
            type: 'workDetails',
            commodity: null,
            item_number: null,
            item_type: null,
            workItem: {
                id: null,
                type: 'workItems',
            },

            relationshipNames: ['workItem'],
        },
        available_workItems_dropdown: [],

    }),

    created () {
        this.get();
        this.getWorkItems();
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                // return service.get(id)
                //     .then((response)=>{
                //         console.log(response);
                //     });
                // console.log(this.$store.dispatch("activities/get", id));
                await this.$store.dispatch('workDetails/get', id);
                console.log(this.$store.getters);
                this.workDetail = this.$store.getters['workDetails/workDetail'];
                console.log(this.workDetail);
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            if (
                this.$isDemo == 1 &&
                    ['1', '2', '3'].includes(this.$route.params.id)
            ) {
                await this.$store.dispatch(
                    'alerts/error',
                    'You are not allowed to change data of default roles.'
                );
                return;
            }
            try {
                await this.$store.dispatch('workDetails/update', this.workDetail);
                await this.$store.dispatch(
                    'alerts/success',
                    'Work Detail updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        getWorkItems () {
            this.$store.dispatch('workItems/list').then(() => {
                //  console.log(this.$store)
                this.available_workItems_dropdown = this.$store.getters['workItems/list'];
                // console.log(this.available_activities_dropdown)
            });
        },

        goBack () {
            this.$router.push({ name: 'Work Details List' });
        },
    },
};
</script>
